import React from "react";
import Button from "../../components/button/Button";
import { Link } from "react-router-dom";

const OfficeMapSection = () => {
  return (
    <section className="w-full flex flex-col md:flex-row md:h-60 h-96 mt-16 relative">
      {/* Map */}
      <div className="md:w-1/2 w-full h-96 md:h-full">
        <iframe
          title="Office Location"
          src="https://www.google.com/maps?q=11%2C%20Sampat%20Hills%2C%20Bicholi%20Mardana%2C%20Indore%2C%20Madhya%20Pradesh%20452016&output=embed"
          width="100%"
          height="100%"
          style={{ border: 0 }}
          allowFullScreen=""
          loading="lazy"
          referrerpolicy="no-referrer-when-downgrade"
        ></iframe>
      </div>
      <div className="md:w-1/2 w-full h-96 md:h-full">
        <iframe
          title="Office Location"
          src="https://www.google.com/maps?q=11%2C%20Sampat%20Hills%2C%20Bicholi%20Mardana%2C%20Indore%2C%20Madhya%20Pradesh%20452016&output=embed"
          width="100%"
          height="100%"
          style={{ border: 0, pointerEvents: "none" }}
          allowFullScreen=""
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        ></iframe>
      </div>

      {/* Info Section */}
      <div className="w-full h-1/2 md:h-full bottom-0 right-0 md:w-1/2 bg-primary-500 bg-opacity-85 flex flex-col justify-center px-6 py-8 space-y-2 md:space-y-4 absolute">
        <h2 className="text-xl font-bold bg-white relative p-3 -left-6 w-48 text-end">
          Head Office
        </h2>
        <p className="md:pl-12">
          11, Sampat Hills, Bicholi Mardana, Indore
          <br />
          -452016 (M.P.)
        </p>
        <div className="flex gap-4 mt-4 md:pl-12">
          <Link
            to={
              "https://www.google.co.in/maps/place/9,+Shreeji+Heights,+Sahara+City+Homes,+Indore,+Madhya+Pradesh+452016/@22.6944711,75.9265266,17.3z/data=!4m14!1m7!3m6!1s0x3962e319ffebc92d:0x4b6b84d40b87eba8!2s11,+Sampat+Hills+Rd,+Pragati+Vihar,+Madhya+Pradesh+452016!3b1!8m2!3d22.6950516!4d75.9290841!3m5!1s0x3962e319c5f08559:0x44f29258d725b674!8m2!3d22.6957625!4d75.9267703!16s%2Fg%2F11j59bvw4_?entry=ttu&g_ep=EgoyMDI2MDkwNi4wIKXMDSoASAFQAw%3D%3D"
            }
            target="_block"
          >
            <Button variant="outline">View Larger Map</Button>
          </Link>
          <Link
            to={
              "https://www.google.co.in/maps/place/9,+Shreeji+Heights,+Sahara+City+Homes,+Indore,+Madhya+Pradesh+452016/@22.6944711,75.9265266,17.3z/data=!4m14!1m7!3m6!1s0x3962e319ffebc92d:0x4b6b84d40b87eba8!2s11,+Sampat+Hills+Rd,+Pragati+Vihar,+Madhya+Pradesh+452016!3b1!8m2!3d22.6950516!4d75.9290841!3m5!1s0x3962e319c5f08559:0x44f29258d725b674!8m2!3d22.6957625!4d75.9267703!16s%2Fg%2F11j59bvw4_?entry=ttu&g_ep=EgoyMDI2MDkwNi4wIKXMDSoASAFQAw%3D%3D"
            }
            target="_block"
          >
            <Button variant="outline">Directions</Button>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default OfficeMapSection;
